import { jsx as _jsx } from "react/jsx-runtime";
export const LineBreak = ({ data, options }) => options?.lineBreak ? options.lineBreak(data) : _jsx("br", {});
